export default __webpack_public_path__ + "static/media/img_blanketBase_grey_p.166ce9f4.jpg";